<template lang="pug">
div.cate-grid(class="grid grid-cols-1 sm:grid-cols-2 gap-2")
  div.cate-option.relative
    Card.p-0.select-mark(@click.native="selectCate('allplatform')" v-bind:class="{ selected: selectedCate === 'allplatform' }" class="cursor-pointer")
      CardContent.p-6
        h2 {{ $t('allplatform') }}
        PTag.text-xs.select-mark-tag.hide-for-small.top-right(:type="serviceFound('allplatform').type" size="small" v-if="loggedIn && serviceFound('allplatform')" v-bind:class="[serviceFound('allplatform').content]")
          span {{ $t(serviceFound('allplatform').content) }}
        h3.detail
          | {{ $t('services.allplatform.desc') }}
        h4.site-icons
          //- Google#google
          Icon(name="logos:google-icon" class="h-6 inline-block")
          Icon(name="line-md:twitter-x" class="h-6 inline-block")
          Icon(name="logos:youtube-icon" class="h-6 inline-block")
          Icon(name="logos:openai" class="h-6 inline-block openai-logo")
        PLink.choose(type="success" plain) {{ $t('pricing.choose') }}
        Icon(name="material-symbols:check-small-rounded" class="checkmark")
  div.cate-option.relative
    Card.p-0.select-mark(@click.native="selectCate('home')" v-bind:class="{ selected: selectedCate === 'home' }" class="cursor-pointer")
      CardContent.p-6
        h2 {{ $t('home') }}
        PTag.text-xs.select-mark-tag.hide-for-small.top-right(:type="serviceFound('home').type" size="small" v-if="loggedIn && serviceFound('home')" v-bind:class="[serviceFound('home').content]")
          span {{ $t(serviceFound('home').content) }}
        h3.detail
          | {{ $t('services.home.desc') }}
        h4.site-icons
          //- img.youku(src="/img/Youku_logo.svg" loading="lazy")
          img.bilibili(src="https://alicloud-assets.oss-accelerate.aliyuncs.com/img/bilibili-logo-blue.svg" loading="lazy")
          //- BiliBili#BiliBili

          //- Icon#BiliBili(icon="arcticons:bilibili")
          Icon#netease(name="ri:netease-cloud-music-fill" class="h-6 inline-block")
          img.qq-music(src="https://alicloud-assets.oss-accelerate.aliyuncs.com/img/qq-music-1.svg" loading="lazy")
        PLink.choose(type="success" plain) {{ $t('pricing.choose') }}
        Icon(name="material-symbols:check-small-rounded" class="checkmark")
</template>

<script lang="ts" setup>
import { Card, CardContent } from '@/components/ui/card'

const props = defineProps<{
  modelValue: string
}>()
const emit = defineEmits(['update:modelValue'])

const session = useVisitorSession()
const service = useUserService()

const selectedCate = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})
const loggedIn = computed(() => session.loggedIn)

function selectCate(cate) {
  selectedCate.value = cate
  console.log('new cate:', cate)
  useScrollTo({ el: '#plan', offset: -200, mobileOnly: true })
}
function serviceFound(cate) {
  const s = service[cate]
  const content = s ? (s.status === 'on' ? 'using' : 'been_used') : 'never'
  const typeMap = {
    using: 'success',
    been_used: 'warning',
    never: 'info',
  }
  return {
    content,
    type: typeMap[content] as 'success' | 'warning' | 'info' | 'danger',
  }
}
</script>

<style lang="postcss" scoped>

.site-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;

  img,
  svg {
    height: 1.5rem;
    width: auto;
    object-fit: contain;
    display: inline-block;
  }

  .iconify {
    font-size: 1.5rem;
    vertical-align: middle;
  }
}

.dark .openai-logo {
  filter: invert(1);
}

#netease {
  color: rgb(230, 0, 38);

  path {
    fill: rgb(230, 0, 38);
  }
}

#google {
  width: 3.5rem;
}

h2 {
  font-size: 26px;
  line-height: 32px;
  display: block;
  margin: 0 auto 0.5rem;

  /* margin: 0 0 16px; */
  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 34px;
  }
}

h3 {
  &.detail {
    color: var(--secondary-color);
    font-weight: 300;
    margin-bottom: 0.5rem;
  }
}

.select-mark-tag {
  &.top-right {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 11px;
    border-radius: 15px;
    /* color: #000000; */
  }
}

.cate-option {
  min-width: 0;
  max-width: 100%;

  .card {
    width: 100%;
    position: relative;

    /* box-shadow: var(--shadow-smallest); */
    @media screen and (max-width: 768px) {
      margin-bottom: 1rem;
    }
  }
}

.cate-grid,
.cate-option,
.cate-option [data-slot='card'] {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

@media (max-width: 768px) {
  .cate-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .cate-option,
  .cate-option [data-slot='card'] {
    width: 100% !important;
    max-width: 100%;
  }
}
</style>
